import { render, staticRenderFns } from "./MunuCollapsible.vue?vue&type=template&id=a18725ec&scoped=true"
import script from "./MunuCollapsible.vue?vue&type=script&lang=js"
export * from "./MunuCollapsible.vue?vue&type=script&lang=js"
import style0 from "./MunuCollapsible.vue?vue&type=style&index=0&id=a18725ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18725ec",
  null
  
)

export default component.exports